module.exports = __webpack_public_path__ + "glyphicons-social-regular.c0e182c1734f49ca10b4.ttf";


//////////////////
// WEBPACK FOOTER
// /opt/app/develop/src/assets/css/fonts/glyphicons.social.pro/glyphicons-social-regular.ttf
// module id = ../../../../../src/assets/css/fonts/glyphicons.social.pro/glyphicons-social-regular.ttf
// module chunks = 2